import script from "./DataSummery.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataSummery.vue?vue&type=script&setup=true&lang=ts"

import "./DataSummery.vue?vue&type=style&index=0&id=50ce8884&lang=sass"

const __exports__ = script;

export default __exports__